import { CONFIRMATION_FIELD_VALID, confirmationFieldValidator, CRYPTOPW_VALIDATOR, CRYPTOPW_VALIDATOR_DEPRECATED, cryptoPWValidator, cryptoPWValidatorDeprecated, NEW_CRYPTOPW_VALIDATOR, newCryptoPWValidatorValidator } from '../../utils/user-util';
import BaseController from '../BaseController';
import { FieldAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';

export default class ChangePasswordCommonsController extends BaseController {

  onMountModalAltSenha(fieldActualPassword: FieldAPI, fieldNewPassword: FieldAPI, fieldNewConfirmPassword: FieldAPI, formPassword: FormAPI,): void {
    fieldActualPassword.addLocalValidator(CRYPTOPW_VALIDATOR_DEPRECATED, cryptoPWValidatorDeprecated);
    fieldNewPassword.addLocalValidator(CRYPTOPW_VALIDATOR, cryptoPWValidator);
    fieldNewConfirmPassword.addLocalValidator(CONFIRMATION_FIELD_VALID, (value) => {
      const confirmationValue = formPassword.getRecord()['newPassword'] || '';
      return confirmationFieldValidator(value, confirmationValue);
    });
    fieldNewPassword.addLocalValidator(NEW_CRYPTOPW_VALIDATOR, (value) => {
      const senhaAtual = formPassword.getRecord()['password'] || '';
      return newCryptoPWValidatorValidator(value, senhaAtual);
    });
  }

  async isDataValid(fieldActualPassword: FieldAPI, fieldNewPassword: FieldAPI, fieldNewConfirmPassword: FieldAPI, value: Record<string, Value>): Promise<boolean> {
    return await fieldActualPassword.validate() &&
      await fieldNewPassword.validate() &&
      await fieldNewConfirmPassword.validate() &&
      Boolean(value['password']) &&
      Boolean(value['newPassword']) &&
      Boolean(value['confirmPassword']) &&
      (value['newPassword'] === value['confirmPassword']);
  }
}
